import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
export function WhatsAppButton() {
  const phoneNumber = '6281114477977'; // Format internasional tanpa +
  const whatsappUrl = `https://wa.me/${phoneNumber}`;
  return <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full shadow-lg hover:shadow-xl flex items-center justify-center transition-all duration-300 transform hover:scale-110 group" aria-label="Chat via WhatsApp" data-id="element-87">
      <MessageCircleIcon className="w-7 h-7 text-white" data-id="element-88" />
      <span className="absolute right-full mr-3 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-89">
        Chat dengan kami
      </span>
    </a>;
}